module.exports = __webpack_public_path__ + "img/AdobeStock_277586010.a23e9619.jpeg";